//TermsPrivacy.jsx:
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadSection from '../components/DownloadSection';
import Header from '../components/Header';
import './TermsPrivacy.css';

function TermsPrivacy() {
    const { t } = useTranslation();

    // Scroll to top when the page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Create a ref for the DownloadSection
    const downloadRef = useRef(null);

    // Scroll function
    const scrollToDownload = () => {
        if (downloadRef.current) {
            downloadRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div>
            {/* Pass scrollToDownload to Header */}
            <Header scrollToDownload={scrollToDownload} />

            {/* Terms & Privacy Content */}
            <div className="terms-privacy-container">
                <div className="header-container">
                    <h1>{t("terms_privacy.line_2")}</h1>
                    <p>{t("terms_privacy.line_3")}</p>
                </div>
                <h1>{t("terms_privacy.line_4")}</h1>
                <p>{t("terms_privacy.line_5")}</p>
                <p><strong>{t("terms_privacy.line_6")}</strong></p>
                <p><strong>{t("terms_privacy.line_7")}</strong></p>
                <p><strong>{t("terms_privacy.line_8")}</strong></p>
                <p>{t("terms_privacy.line_9")}</p>

                <p>{t("terms_privacy.line_10")}</p>
                <h2>{t("terms_privacy.line_11")}</h2>
                <h3>{t("terms_privacy.line_12")}</h3>

                <h1>{t("terms_privacy.line_13")}</h1>
                <h2>{t("terms_privacy.line_14")}</h2>
                <h4>{t("terms_privacy.line_15")}</h4>
                <p>{t("terms_privacy.line_16")}</p>

                <h4>{t("terms_privacy.line_17")}</h4>
                <p>{t("terms_privacy.line_18")}</p>

                <h2>{t("terms_privacy.line_19")}</h2>
                <h4>{t("terms_privacy.line_20")}</h4>
                <p>{t("terms_privacy.line_21")}</p>

                <h4>{t("terms_privacy.line_22")}</h4>
                <p>{t("terms_privacy.line_23")}</p>

                <h4>{t("terms_privacy.line_24")}</h4>
                <p>{t("terms_privacy.line_25")}</p>

                <h2>{t("terms_privacy.line_26")}</h2>
                <h4>{t("terms_privacy.line_27")}</h4>
                <p>{t("terms_privacy.line_28")}</p>

                <h4>{t("terms_privacy.line_29")}</h4>
                <p>{t("terms_privacy.line_30")}</p>

                <h2>{t("terms_privacy.line_31")}</h2>
                <h4>{t("terms_privacy.line_32")}</h4>
                <p>{t("terms_privacy.line_33")}</p>

                <h4>{t("terms_privacy.line_34")}</h4>
                <p>{t("terms_privacy.line_35")}</p>

                <h2>{t("terms_privacy.line_36")}</h2>
                <h4>{t("terms_privacy.line_37")}</h4>
                <p>{t("terms_privacy.line_38")}</p>

                <h4>{t("terms_privacy.line_39")}</h4>
                <p>{t("terms_privacy.line_40")}</p>

                <h2>{t("terms_privacy.line_41")}</h2>
                <h4>{t("terms_privacy.line_42")}</h4>
                <p>{t("terms_privacy.line_43")}</p>

                <h4>{t("terms_privacy.line_44")}</h4>
                <p>{t("terms_privacy.line_45")}</p>

                <h1>{t("terms_privacy.line_46")}</h1>
                <h2>{t("terms_privacy.line_47")}</h2>
                <p>{t("terms_privacy.line_48")}</p>

                <h4>{t("terms_privacy.line_49")}</h4>
                <p>{t("terms_privacy.line_50")}</p>
                <p>{t("terms_privacy.line_51")}</p>
                <p>{t("terms_privacy.line_52")}</p>
                <p>{t("terms_privacy.line_53")}</p>

                <h4>{t("terms_privacy.line_54")}</h4>
                <p>{t("terms_privacy.line_55")}</p>
                <p>{t("terms_privacy.line_56")}</p>

                <h3>{t("terms_privacy.line_57")}</h3>
                <p>{t("terms_privacy.line_58")}</p>
                <p>{t("terms_privacy.line_59")}</p>
                <p>{t("terms_privacy.line_60")}</p>

                <h2>{t("terms_privacy.line_61")}</h2>
                <p>{t("terms_privacy.line_62")}</p>
                <h4>{t("terms_privacy.line_63")}</h4>

                <p>{t("terms_privacy.line_64")}</p>
                <h4>{t("terms_privacy.line_65")}</h4>

                <p>{t("terms_privacy.line_66")}</p>
                <h4>{t("terms_privacy.line_67")}</h4>

                <p>{t("terms_privacy.line_68")}</p>
                <h4>{t("terms_privacy.line_69")}</h4>

                <p>{t("terms_privacy.line_70")}</p>
                <h4>{t("terms_privacy.line_71")}</h4>

                <p>{t("terms_privacy.line_72")}</p>
                <h4>{t("terms_privacy.line_73")}</h4>
                
                <p>{t("terms_privacy.line_74")}</p>

                <h2>{t("terms_privacy.line_75")}</h2>
                <p>{t("terms_privacy.line_76")}</p>

                <h4>{t("terms_privacy.line_77")}</h4>
                <p>{t("terms_privacy.line_78")}</p>

                <h4>{t("terms_privacy.line_79")}</h4>
                <p>{t("terms_privacy.line_80")}</p>

                <h2>{t("terms_privacy.line_81")}</h2>
                <p>{t("terms_privacy.line_82")}</p>

                <h2>{t("terms_privacy.line_83")}</h2>
                <p>{t("terms_privacy.line_84")}</p>

                <h4>{t("terms_privacy.line_85")}</h4>
                <p>{t("terms_privacy.line_86")}</p>

                <p>{t("terms_privacy.line_87")}</p>
                <p>{t("terms_privacy.line_88")}</p>

                <p>{t("terms_privacy.line_89")}</p>
                <p>{t("terms_privacy.line_90")}</p>

                <h2>{t("terms_privacy.line_91")}</h2>
                <p>{t("terms_privacy.line_92")}</p>

                <p>{t("terms_privacy.line_93")}</p>
                <h2>{t("terms_privacy.line_94")}</h2>

                <p>{t("terms_privacy.line_95")}</p>
                <h2>{t("terms_privacy.line_96")}</h2>

                <p>{t("terms_privacy.line_97")}</p>
                <p>{t("terms_privacy.line_98")}</p>

                <h2>{t("terms_privacy.line_99")}</h2>
                <p>{t("terms_privacy.line_100")}</p>

                <p>{t("terms_privacy.line_101")}</p>
                <h4>{t("terms_privacy.line_102")}</h4>
            </div>

            {/* Wrap DownloadSection in a ref for scrolling */}
            <div ref={downloadRef} className="download-section-anchor">
                <DownloadSection />
            </div>
        </div>
    );
}

export default TermsPrivacy;
